import { useContext, useState } from "react";
import styled from "styled-components";
import Questionario from "./Questionario/Questionario";
import Home from "./Home/Home";
import { PageContext } from "../Context/PageContext";

function Content() {

    const {page} = useContext(PageContext);

    return(
        <MasterContainer>
            {page}
        </MasterContainer>
    )
}

export default Content;

const MasterContainer = styled.div`
    //border: 1px solid rgba(0,0,0,.2);
    margin-top: 20px;
    border-radius: 5px;

`